function doSalt(l) {
  const result = [];
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  let counter = l;
  while (counter > 0) {
    counter -= 1;
    result.push(chars.charAt(Math.floor(Math.random() * chars.length)));
  }

  return result.join('');
}

function hexString(buffer) {
  const byteArray = new Uint8Array(buffer);

  const hexCodes = [...byteArray].map(value => {
    const hexCode = value.toString(16);
    return hexCode.padStart(2, '0');
  });

  return hexCodes.join('');
}

async function sha1(message) {
  const encoder = new TextEncoder();
  const data = encoder.encode(message);
  const digest = await window.crypto.subtle.digest('SHA-1', data);
  return hexString(digest);
}

async function doMint(challenge, bits) {
  let counter = 0;
  const hex_digits = Math.ceil(bits / 4);
  const zeros = '0'.repeat(hex_digits);

  while (true) {
    const digest = await sha1(challenge + counter.toString(16));
    if (digest.slice(0, hex_digits) === zeros) {
      return counter.toString(16);
    }
    counter += 1;
  }
}

export default async function mint(resource, bits = 12, now = null, ext = '', saltchars = 8) {
  const ver = '1';
  const nowParam = now || new Date();
  const ts = Math.ceil(nowParam.valueOf() / 1000);
  const salt = doSalt(saltchars);
  const challenge = `${ver}:${bits}:${ts}:${resource}:${ext}:${salt}:`;
  return challenge + (await doMint(challenge, bits));
}
